<div class="d-flex">
  <div class="flex-even">
    <gpu-form-field [appearance]="formFieldAppearance">
      <gpu-label>{{ question.answers[0].name }}</gpu-label>
      <gpu-select
        formControlName="hours"
        [placeholder]="question.answers[0].name"
        (selectChanged)="track('value', $event)"
      >
        <gpu-option *ngFor="let option of sleepingHours" [value]="option.value">
          {{ option.label }}
        </gpu-option>
      </gpu-select>
    </gpu-form-field>
  </div>

  <span
    class="sleeping-separator d-flex align-items-center justify-content-center i1-regular text-muted"
  >
    :
  </span>

  <div class="flex-even">
    <gpu-form-field [appearance]="formFieldAppearance">
      <gpu-label>
        {{ 'RESULTS.HABITS.QUESTIONNAIRE.MINUTES' | translate }}
      </gpu-label>
      <gpu-select
        formControlName="minutes"
        [placeholder]="'RESULTS.HABITS.QUESTIONNAIRE.MINUTES' | translate"
        (selectChanged)="track('minutes', $event)"
      >
        <gpu-option
          *ngFor="let option of sleepingMinutes"
          [value]="option.value"
        >
          {{ option.label }}
        </gpu-option>
      </gpu-select>
    </gpu-form-field>
  </div>
</div>

<small
  *ngIf="form.controls.hours.touched && form.controls.hours.errors?.required"
  class="form-text text-danger gpt-8 gpl-16"
>
  {{ 'ANALYSES.VALUE_REQUIRED' | translate }}
</small>
